module.exports = __webpack_public_path__ + "static/media/dealer_b_1280.264e130a.png";